import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { servicesList } from '../data/servicesData';
import { ArrowLeft } from 'lucide-react';

const Services = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const borderColors = [
        "#3b82f6", "#10b981", "#f59e0b", "#8b5cf6",
        "#ec4899", "#06b6d4", "#f43f5e", "#6366f1"
    ];

    return (
        <div className="p-4 md:p-6 pb-20 md:pb-6 space-y-6 animate-in fade-in duration-500">

            {/* Header */}
            <div className="flex items-center justify-between mb-4">
                <div className="flex items-center gap-3">
                    <button
                        onClick={() => navigate(-1)}
                        className="md:hidden p-2 -ml-2 rounded-full hover:bg-slate-100 transition-colors"
                        aria-label="Go back"
                    >
                        <ArrowLeft size={20} className="text-slate-700" />
                    </button>
                    <h1 className="text-xl md:text-2xl font-bold text-slate-900 font-poppins">
                        {t('dashboard:services.title')}
                    </h1>
                </div>
            </div>

            {/* Services Grid */}
            <div className="bg-white/50 backdrop-blur-sm border border-white/40 rounded-3xl p-6 shadow-sm">
                <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 gap-y-8 gap-x-4">
                    {servicesList.map((service, index) => {
                        const borderColor = borderColors[index % borderColors.length];

                        return (
                            <button
                                key={service.id}
                                onClick={() => navigate(service.route)}
                                className="flex flex-col items-center group transition-transform hover:scale-105 focus:outline-none"
                            >
                                {/* Icon Container */}
                                <div
                                    className="w-14 h-14 md:w-16 md:h-16 bg-white rounded-2xl flex items-center justify-center mb-3 shadow-[0_4px_15px_-3px_rgba(0,0,0,0.1)] border-[1.5px] transition-all group-hover:shadow-md relative overflow-hidden"
                                    style={{ borderColor: borderColor }}
                                >
                                    {/* Shadow glow effect inline style backup since tailwind arbitrary shadow color support varies */}
                                    <div
                                        className="absolute inset-0 opacity-10"
                                        style={{ backgroundColor: borderColor }}
                                    />

                                    {service.logo ? (
                                        <img
                                            src={service.logo}
                                            alt={t(service.nameKey)}
                                            className={`object-contain ${service.id === 13 ? 'w-[54px] h-[54px]' : 'w-9 h-9 md:w-10 md:h-10'}`} // Special case for id 13 as seen in mobile code
                                        />
                                    ) : (
                                        <div className="text-slate-700">
                                            {/* We need to clone the element to pass className if needed, or ensuring the icon has colors from data */}
                                            {service.icon}
                                        </div>
                                    )}
                                </div>

                                {/* Title */}
                                <span className="text-[11px] md:text-xs font-medium text-slate-700 text-center leading-tight line-clamp-2 w-full px-1 font-poppins">
                                    {t(service.nameKey)}
                                </span>
                            </button>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default Services;
